import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { get } from 'lodash-es';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { getFuelTypeIcons } from 'site-modules/shared/components/mpg/utils/mpg';

export function CostToDrive({ modelName, fuelCostsData = null, stateName = null, isPHEV = false, isElectric = false }) {
  const costPerMonth = get(fuelCostsData, 'fuelCosts.costPerMonth', 0);
  const avgCostPerMonth = get(fuelCostsData, 'statistics.byBodyTypeAndSize.combustionEngines.averageCostPerMonth', 0);
  const averageCategory = get(fuelCostsData, 'vehicleData.primaryBodyType', '');

  return (
    <div className="cost-to-drive">
      <Row className="pos-r mb-1_5">
        <Col xs={6} className="text-center">
          {getFuelTypeIcons({ isElectric, isPHEV }).map(fuelTypeIcon => (
            <i
              key={fuelTypeIcon}
              className={classnames('size-24 type-icon mb-0_5 d-inline-block', fuelTypeIcon)}
              aria-hidden
            />
          ))}
          <div className={classnames({ 'heading-4': costPerMonth, 'heading-5': !costPerMonth })}>
            {costPerMonth ? <Fragment>{getPriceString(costPerMonth)}/mo</Fragment> : 'Not EPA Tested'}
          </div>
          <div className="medium">{modelName}</div>
        </Col>
        {!!avgCostPerMonth && (
          <Fragment>
            <div className="vs-separator pos-a center-x h-100 p-0 m-0 w-auto">
              <div className="pos-a center-xy bg-white fw-bold text-gray-dark medium py-0_25">vs</div>
            </div>
            <Col xs={6} className="text-center">
              <i className="icon-gas size-24 text-cool-gray-50 mb-0_5" aria-hidden />
              <div className="size-20 fw-bold text-cool-gray-50">{getPriceString(avgCostPerMonth)}/mo</div>
              <div className="medium">{averageCategory ? `Avg. ${averageCategory}` : 'Similar Gas Vehicles'}</div>
            </Col>
          </Fragment>
        )}
      </Row>
      {!!costPerMonth && <div className="medium">Monthly estimates based on costs in {stateName}</div>}
    </div>
  );
}

CostToDrive.propTypes = {
  modelName: PropTypes.string.isRequired,
  fuelCostsData: VehicleEntities.StyleFuelCostData,
  stateName: PropTypes.string,
  isPHEV: PropTypes.bool,
  isElectric: PropTypes.bool,
};
